import React from "react";
/* eslint-disable */
import {
  Box, TableBody, TableCell, TableContainer, TableHead, TableRow, Table
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

  render() {
    const tableData = this.props.tableData;
    const searchData = this.props.searchData;

    return (
      <div>
        <h3><center><u>Daily Price Update Report</u></center></h3>
        <h4><center>{searchData.groupID} - {searchData.operationEntityID}</center></h4>
        <h4><center>{searchData.date}</center></h4>
        <div>&nbsp;</div>
        <h4><center></center></h4>
        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Product</TableCell>
                  <TableCell align="center">Qty(Kg)</TableCell>
                  <TableCell align="center">PP(Rs)</TableCell>
                  <TableCell align="center">AP(Rs) </TableCell>
                  <TableCell align="center">2nd PP(Rs)</TableCell>
                  <TableCell align="center">RP(Rs) </TableCell>
                  <TableCell align="center">2nd PP Status</TableCell>
                  <TableCell align="center">Status</TableCell>
                  <TableCell align="center">Realized Price Status</TableCell>
                  <TableCell align="center">Harti Price Last Updated Date</TableCell>
                  <TableCell align="center">Min(Rs)	 </TableCell>
                  <TableCell align="center">Max(Rs) </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tableData.map((data, index) => (
                  <TableRow key={index}>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.productName}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.proposedQuantity == 0 ? parseFloat(data.quantity).toFixed(2) : parseFloat(data.proposedQuantity).toFixed(2)}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.proposedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.approvedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.secondProposedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.realizedPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.secondProposedPriceStatus == 0 ? 'Not Set'
                        : data.secondProposedPriceStatus == 1 ? 'Pending'
                          : data.secondProposedPriceStatus == 2 ? 'Approved'
                            : data.secondProposedPriceStatus == 3 ? 'Rejected' : ''}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.status == 4 ? 'Rejected'
                        : data.status == 3 ? 'Approved'
                          : data.status == 1 ? 'Pending'
                            : data.status == 2 ? 'Pending'
                              : data.status == 0 ? 'New' : ''}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.realizedPriceStatus == 4 ? 'Rejected'
                        : data.realizedPriceStatus == 3 ? 'Approved'
                          : data.realizedPriceStatus == 1 ? 'New'
                            : data.realizedPriceStatus == 2 ? 'Pending'
                              : data.realizedPriceStatus == 0 ? 'Not Set' : ''}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.date == '-' ? '-' : data.date.split('T')[0]}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.minPrice == '-' ? '-' : data.minPrice.toFixed(2)}
                    </TableCell>
                    <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                      {data.maxPrice == '-' ? '-' : data.maxPrice.toFixed(2)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <h4><center>----End of the list----</center></h4>
      </div>
    );
  }
}
